import React from "react";
import AdminSidebar from "../components/AdminSidebar";
import ProfileHeader from "../components/ProfileHeader";
import ComplaintControl from "../components/ComplaintControl";

const ComplaintControlPage = () => {
  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar on the left */}
      <AdminSidebar />

      {/* Main content area */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
        {/* Profile Header at the top */}
        <ProfileHeader />

        {/* Complaint Control content */}
        <ComplaintControl />
      </div>
    </div>
  );
};

export default ComplaintControlPage;
